import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { useQuery } from "@tanstack/react-query";

export function useRequireRole(role: "admin" | "moderator" | "user") {
  const { user, loading: authLoading } = useAuth();

  const { data: hasRole = false, isLoading } = useQuery({
    queryKey: ["user-role", user?.id, role],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("has_role", {
        _user_id: user!.id,
        _role: role,
      });
      if (error) return false;
      return !!data;
    },
    enabled: !!user && !authLoading,
    staleTime: 5 * 60 * 1000, // 5 min cache
    refetchOnWindowFocus: false,
  });

  return { hasRole, loading: authLoading || isLoading };
}
